"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const eventemitter3_1 = require("eventemitter3");
class BaseConnection extends eventemitter3_1.EventEmitter {
    constructor(peer, provider, options) {
        super();
        this.peer = peer;
        this.provider = provider;
        this.options = options;
        this._open = false;
        this.metadata = options.metadata;
        this.config = options.config;
    }
    get open() {
        return this._open;
    }
}
exports.BaseConnection = BaseConnection;
